import {useGeneralProvider} from 'brand/app/components/_app-config/GeneralProvider';
import {useSelector} from 'react-redux';
import {useVersioned} from 'coreUtils/adapters/versioned';
import {selectPromotions} from '../../store/data/promotions';

/**
 * usePromotionsMgr custom hook
 */
export default function usePromotionsMgr() {
	const {managerRepository} = useGeneralProvider();

	const promotions = useSelector((state) => selectPromotions(state));

	return useVersioned(managerRepository.getPromotionsMgr(), promotions);
};
